import React from "react";
import SnackbarProvider from "react-simple-snackbar";
import "swiper/css/swiper.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const wrapRootElement = ({ element }) => {
  return <SnackbarProvider>{element}</SnackbarProvider>;
};
